import { render, staticRenderFns } from "./KycContainer.vue?vue&type=template&id=5fcc339e&scoped=true&"
import script from "./KycContainer.vue?vue&type=script&lang=js&"
export * from "./KycContainer.vue?vue&type=script&lang=js&"
import style0 from "./KycContainer.vue?vue&type=style&index=0&id=5fcc339e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcc339e",
  null
  
)

export default component.exports